import React from "react";
import { type IColumn } from "@fluentui/react";
import { type UUID } from "../../utils/uuid";
import { observer } from "mobx-react";
import { computed, makeObservable } from "mobx";
import { type Phone, type VehicleDevice } from "../../api";

interface ListPhoneItemCellProps {
    readonly phoneId: UUID;
    readonly column: IColumn;
}
import { store } from "../../store";

@observer
export class ListPhoneItemCell extends React.Component<ListPhoneItemCellProps> {
    constructor(props: ListPhoneItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get phone(): Phone | undefined {
        return store.repositoryPhones.byId(this.props.phoneId);
    }

    @computed private get vehicleDevice(): VehicleDevice | undefined {
        if (!this.phone?.vehicleDeviceId) {
            return;
        }

        return store.repositoryVehicleDevices.byId(this.phone.vehicleDeviceId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        if (!this.phone) {
            return <></>;
        }
        switch (column.key) {
            case "vehicleDeviceId":
                return this.vehicleDevice ? (
                    <span>{this.vehicleDevice.serialNumber}</span>
                ) : (
                    <span />
                );
            case "androidId":
                return <span>{this.phone.androidId}</span>;
            case "appLastUpdatedAt":
                return <span>{store.i18n.formatDateTime(this.phone.appLastUpdatedAt)}</span>;
            case "currentAppVersion":
                return <span>{this.phone.currentAppVersion}</span>;
            default:
                return <></>;
        }
    }
}
